(function ($) {

    $(document).ready(function () {
        if ($(".umbraco-forms-field.paginatitel").length) {
            const pageName = $(".page-title").length ? $(".page-title").text() : $("head title").text();
            $(".umbraco-forms-field.paginatitel input").val(pageName);
        }
        
        if ($(".umbraco-forms-field.mailontvanger").length && $("#formMailTo").length) {
            const formMailTo = $("#formMailTo").text();
            $(".umbraco-forms-field.mailontvanger input").val(formMailTo);
        }
    });

})(jQuery);